import React from 'react'
import Client from '@searchkit/instantsearch-client'
import {
  useQueryRules,
  Stats,
  CurrentRefinements,
  // DynamicWidgets,
  InstantSearch,
  SearchBox,
  InfiniteHits,
  RefinementList,
  // Snippet,
  Highlight,
  // Configure,
  // Pagination,
  SortBy,
} from 'react-instantsearch'
import { SnippetWithTrimIfNotHighlighted } from './SnippetWithTrimIfNotHighlighted'

// import { DateRangePicker } from '@algolia/react-instantsearch-widget-date-range-picker'
import { history } from 'instantsearch.js/es/lib/routers'
import format from 'date-fns/format'

const routing = {
  // TODO
  // by default - http://localhost:3000/search?publications%5Bquery%5D=ad
  // should be - http://localhost:3000/search?q=ad
  router: history({
    // createURL({ qsModule, location, routeState }) {
    //   console.log({ qsModule, location, routeState })
    //   const { origin, pathname, hash } = location;
    //   const indexState = routeState['publications'] || {};
    //   const queryString = qsModule.stringify(routeState);
    //   console.log({ indexState, queryString })
    //   if (!indexState.query) {
    //     return `${origin}${pathname}${hash}`;
    //   }
    //   return `${origin}${pathname}?${queryString}${hash}`;
    // },
  }),
}

// Create a Searchkit client
// This is the configuration for Searchkit, specifying the fields to attributes used for search, facets, etc.
// const sk = new Searchkit(...config)
// const searchClient = Client(sk)

const searchClient = Client({
  // url: '/api/search'
  url: window.appElasticsearchUrl,
})

function HitView (props) {
  console.log(props)

  const {
    author,
    author_url,
    // content,
    featured_image_url,
    featured_image_300_url,
    // featured_image_100_url,
    url,
    publication_date,
    title,
    tags = [],
  } = props.hit

  const publication_date_ = format(new Date(publication_date), 'mm/dd/yyyy')

  const tagsRendered = tags.length <= 0
    ? null
    : (
      <div>
        Tags:{' '}
        {tags.map((tag, index) => (
          <React.Fragment key={index}>
            <span className='tag'>{tag}</span>
            {index !== tags.length - 1 && ', '}
          </React.Fragment>
        ))}
      </div>
      )

  console.log('tagsRendered', tagsRendered)

  return (
    <div className='hit_view'>
      <div className='img-and-title-and-other-details'>
        <a
          href={url}
          className='image_container'
          target='_blank'
          rel='noreferrer'
        >
          <img
            className='featured_image'
            sizes='(max-width: 991px) 500px'
            src={featured_image_url}
            srcSet={`${featured_image_300_url} 300w, ${featured_image_url} 500w`}
            alt={title}
          />
        </a>

        <div className='title-and-other-details'>
          <a className='title' href={url} target='_blank' rel='noreferrer'>
            <Highlight attribute='title' hit={props.hit} />
          </a>
          <div className='by-author-container'>
            By&nbsp;
            <a
              className='author'
              href={author_url}
              target='_blank'
              rel='noreferrer'
            >
              {author}
            </a>
            &nbsp;on&nbsp;
            {publication_date_}
          </div>
          {tagsRendered}
        </div>
      </div>

      <SnippetWithTrimIfNotHighlighted attribute='content' hit={props.hit} separator=' ... ' />
    </div>
  )
}

// {tags.map((tag, index) => <a href={`/latest-posts?tag=${tag}`} target="_blank" key={index} className="tag">{tag}</span>).join(", ")}

function Panel ({ header, children }) {
  return (
    <div className='sk-panel'>
      <h5>{header}</h5>
      {children}
    </div>
  )
}

function QueryRulesBanner () {
  const { items } = useQueryRules({})
  if (items.length === 0) {
    return null
  }
  return (
    <div className='query-rules'>
      {items.map((item) => (
        <div key={item.objectID} className='query-rules__item'>
          <a href={item.url}>
            <b className='query-rules__item-title'>{item.title}</b>
            <span className='query-rules__item-description'>{item.body}</span>
          </a>
        </div>
      ))}
    </div>
  )
}

// <DynamicWidgets facets={['*']}></DynamicWidgets>
// <Panel header="Publication date"><DateRangePicker attribute="publication_date" /></Panel>

function App () {
	console.log("using " + window.appElasticsearchUrl)
  return (
    <InstantSearch
      indexName='publications'
      searchClient={searchClient}
      routing={routing}
    >
      <div className='mysk-root'>
        <SearchBox />

        <div className='mysk-container'>
          <div>
            <Panel header='Publication type'>
              <RefinementList attribute='type' searchable />
            </Panel>
            <Panel header='Authors'>
              <RefinementList attribute='author' searchable showMore />
            </Panel>
            <Panel header='Tags'>
              <RefinementList attribute='tags' searchable showMore />
            </Panel>
          </div>
          <div>
            <SortBy
              items={[
                {
                  label: 'Relevance',
                  value: 'publications',
                },
                {
                  label: 'Most recent first',
                  value: '_publication_date_desc',
                },
                {
                  label: 'Oldest first',
                  value: '_publication_date_asc',
                },
              ]}
            />

            <Stats />
            <CurrentRefinements />
            <QueryRulesBanner />
            <InfiniteHits hitComponent={HitView} />
          </div>
        </div>
      </div>
    </InstantSearch>
  )
}

export default App
